import client from './client';

export interface Ministry {
  id: string;
  name: string;
  owner_id: string;
  invite_code: string;
  created_at: string;
}

export interface MinistryMember {
  id: string;
  ministry_id: string;
  user_id: string;
  user_name: string;
  user_email: string;
  avatar_url: string;
  is_admin: boolean;
  joined_at: string;
}

export async function listMinistries(): Promise<Ministry[]> {
  const res = await client.get('/ministries/');
  return res.data;
}

export async function createMinistry(name: string): Promise<Ministry> {
  const res = await client.post('/ministries/', { name });
  return res.data;
}

export async function getMinistry(ministryId: string): Promise<Ministry> {
  const res = await client.get(`/ministries/${ministryId}/`);
  return res.data;
}

export async function deleteMinistry(ministryId: string): Promise<void> {
  await client.delete(`/ministries/${ministryId}/`);
}

export async function getMinistryMembers(ministryId: string): Promise<MinistryMember[]> {
  const res = await client.get(`/ministries/${ministryId}/members/`);
  return res.data;
}

export async function joinMinistry(inviteCode: string): Promise<Ministry> {
  const res = await client.post(`/ministries/join/${inviteCode}/`);
  return res.data;
}

export async function getMinistryTeams(ministryId: string) {
  const res = await client.get(`/ministries/${ministryId}/teams/`);
  return res.data;
}
